function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import "./StaticDemo.css";

var StaticDemo = /*#__PURE__*/function (_Component) {
  _inheritsLoose(StaticDemo, _Component);

  function StaticDemo() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = StaticDemo.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        content = _this$props.content,
        contentHighlighted = _this$props.contentHighlighted,
        demoOnly = _this$props.demoOnly,
        htmlOnly = _this$props.htmlOnly;
    return /*#__PURE__*/React.createElement("div", {
      className: "StaticDemo"
    }, !htmlOnly && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, 'Static Example'), /*#__PURE__*/React.createElement("div", {
      className: "StaticDemo__example",
      dangerouslySetInnerHTML: {
        __html: content
      }
    })), !demoOnly && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, 'Associated Code'), /*#__PURE__*/React.createElement("pre", {
      className: "StaticDemo__pre language-html"
    }, contentHighlighted && /*#__PURE__*/React.createElement("code", {
      dangerouslySetInnerHTML: {
        __html: contentHighlighted
      }
    }), !contentHighlighted && /*#__PURE__*/React.createElement("code", null, content))));
  };

  return StaticDemo;
}(Component);

StaticDemo.propTypes = {
  content: PropTypes.string,
  contentHighlighted: PropTypes.string,
  demoOnly: PropTypes.bool,
  htmlOnly: PropTypes.bool
};
StaticDemo.defaultProps = {
  demoOnly: false,
  htmlOnly: false
};
export default StaticDemo;
//# sourceMappingURL=StaticDemo.js.map